// EP-59 — labels for the two STI subclasses of Lease. Used by Sidebar
// (nav label), LeaseListPage (header + filter chips), LeaseFields
// (date input labels), and LeaseDetailPage (page header + actions).
// Frontend branches on `accountSettings?.account_type === 'condominium'`
// to pick rental vs ownership copy.
export default {
  entity: {
    rental: 'Lease',
    ownership: 'Co-Ownership',
  },
  list: {
    title: {
      rental: 'Leases',
      ownership: 'Co-Ownerships',
    },
  },
  detail: {
    header: {
      rental: 'Lease #{{code}}',
      ownership: 'Ownership Record #{{code}}',
    },
  },
  customer_role: {
    tenant: 'Tenant',
    shared_owner: 'Co-Owner',
  },
  date_label: {
    start: {
      rental: 'Move-in date',
      ownership: 'Transfer/registration date',
    },
    end: {
      rental: 'Move-out date',
      ownership: 'Sale/transfer date',
    },
  },
  actions: {
    mark_transferred: 'Mark Transferred',
  },
  attachments: {
    rental: 'Lease attachments',
    ownership: 'Ownership documents (SPA, title deed)',
  },
}
